import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M13.4 12l5.3-5.3c.4-.4.4-1 0-1.4a1 1 0 00-1.4 0L12 10.6 6.7 5.3a1 1 0 00-1.4 0 1 1 0 000 1.4l5.3 5.3-5.3 5.3A1 1 0 006 19c.3 0 .5-.1.7-.3l5.3-5.3 5.3 5.3a1 1 0 101.4-1.4L13.4 12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol